import TotalPrice from '../../common/TotalPrice';

export const BONUS_SHOP_COMPONENTS_MAP = {
  TOTAL_PRICE: 'total-price'
};

export const bonusShopComponentsMap = {
  [BONUS_SHOP_COMPONENTS_MAP.TOTAL_PRICE]: TotalPrice
};
